export default __webpack_public_path__ + "static/waterfallvideo-cdef1c23a0339fdfa504ab764cd61632.mp4";